// import { RecentlyViewed } from '@theme/recently-viewed-products';

// class RecentlyViewedProducts extends HTMLElement {
//   async connectedCallback() {
//     const ids = RecentlyViewed.getProducts();

//     if (!ids.length) {
//       this.style.display = 'none';
//       return;
//     }

//     const container = this.querySelector('#recently-viewed-products-list');

//     if (!container) return;

// const currentHandle = window.location.pathname.split('/products/')[1];

// const requests = ids
//   .filter((id) => id !== String(window.meta.product.id))
//   .map(async (id) => {
//     try {
//       const response = await fetch(
//         `/recommendations/products?product_id=${id}&section_id=product-recommendations&intent=related`
//       );

//       return await response.text();
//     } catch {
//       return '';
//     }
//   });

//     const products = await Promise.all(requests);

//     const sections = await Promise.all(requests);

// container.innerHTML = '';

// sections.forEach((html) => {
//   if (!html) return;

//   const doc = new DOMParser().parseFromString(html, 'text/html');

//   doc.querySelectorAll('.resource-list__item').forEach((card) => {
//     container.appendChild(card);
//   });
// });

//     container.innerHTML = products
//       .filter(Boolean)
//       .map((response) => {
//         const product = response.products?.[0];

//         if (!product) return '';

//         return `
//           <div class="product-card">
//             <a href="${product.url}">
//               <img src="${product.images[0]?.src}" alt="${product.title}">
//               <h3>${product.title}</h3>
//             </a>
//           </div>
//         `;
//       })
//       .join('');
//   }
// }

// customElements.define(
//   'recently-viewed-products',
//   RecentlyViewedProducts
// );










import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProducts extends HTMLElement {
  async connectedCallback() {
    const ids = RecentlyViewed.getProducts();

    if (!ids.length) {
      this.style.display = 'none';
      return;
    }

    const container = this.querySelector('#recently-viewed-products-list');

    if (!container) return;

const currentHandle = window.location.pathname.split('/products/')[1];

const requests = ids
  .filter((id) => id !== String(window.meta.product.id))
  .map(async (id) => {
    try {
      const response = await fetch(
        `/recommendations/products?product_id=${id}&section_id=product-recommendations&intent=related`
      );

      return await response.text();
    } catch {
      return '';
    }
  });

    const products = await Promise.all(requests);

    const sections = await Promise.all(requests);

container.innerHTML = '';

sections.forEach((html) => {
  if (!html) return;

  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.querySelectorAll('.resource-list__item').forEach((card) => {
    container.appendChild(card);
  });
});

    container.innerHTML = products
      .filter(Boolean)
      .map((response) => {
        const product = response.products?.[0];

        if (!product) return '';

        return `
          <div class="product-card">
            <a href="${product.url}">
              <img src="${product.images[0]?.src}" alt="${product.title}">
              <h3>${product.title}</h3>
            </a>
          </div>
        `;
      })
      .join('');
  }
}

customElements.define(
  'recently-viewed-products',
  RecentlyViewedProducts
);